import React from 'react';
import { ContactUsDetails } from '../../components/contactUsDetails/contactUsDetails';
import './contactUs.scss';

export const ContactUs = () => {
  return (
    <main aria-label="Contact Us page">
      <h1 className="mainPageHeader">Contact Us</h1>
      <ContactUsDetails />
    </main>
  );
};
